import React from 'react';
import { useTranslation } from 'react-i18next';

interface StatsBarProps {
  totalProducts: number;
  closingValue: number;
  secondaryValue: number;
  mapped: number;
  unmapped: number;
}

const StatsBar: React.FC<StatsBarProps> = ({ totalProducts, closingValue, secondaryValue, mapped, unmapped }) => {
  const { t } = useTranslation();

  return (
    <div className="row mb-4">
      <div className="col-sm-12">
        <div className="card">
          <div className="card-body py-3">
            <div className="d-flex align-items-center justify-content-between w-100">
              <div className="d-flex align-items-center gap-4">
                <span>
                  {t('monthlyStock.verifyStock.pageTexts.statsBar.totalProducts')}: <strong>{totalProducts}</strong>
                </span>
                <span>
                  {t('monthlyStock.verifyStock.pageTexts.statsBar.mapped')}: <strong className="text-success">{mapped}</strong>
                </span>
                <span>
                  {t('monthlyStock.verifyStock.pageTexts.statsBar.unmapped')}: <strong className="text-danger">{unmapped}</strong>
                </span>
              </div>
              <div className="d-flex align-items-center gap-4">
                <span>
                  {t('monthlyStock.verifyStock.pageTexts.statsBar.closingValue')}: <strong>₹{closingValue.toLocaleString()}</strong>
                </span>
                <span>
                  {t('monthlyStock.verifyStock.pageTexts.statsBar.secondaryValue')}: <strong>₹{secondaryValue.toLocaleString()}</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsBar;
